import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface WhatIsZoneModalProps {
	visible: boolean
	onClose: () => void
}

export const WhatIsZoneModal: React.FC<WhatIsZoneModalProps> = ({
	visible,
	onClose,
}) => {
	const { t } = useTranslation('common')

	return (
		<Dialog open={visible} onOpenChange={onClose}>
			<DialogContent
				className="sm:max-w-[500px] p-0 gap-0 overflow-hidden"
				showCloseButton={false}
			>
				<div className="p-6 space-y-6">
					{/* What is a zone section */}
					<div>
						<DialogTitle className="text-lg font-semibold mb-3">
							{t('subscribe.what_is_zone_modal.title')}
						</DialogTitle>
						<p className="text-sm text-muted-foreground leading-relaxed">
							{t('subscribe.what_is_zone_modal.description')}
						</p>
					</div>

					{/* Pricing section */}
					<div className="border-t border-border pt-6">
						<h3 className="text-lg font-semibold mb-3">
							{t('subscribe.what_is_zone_modal.pricing_title')}
						</h3>
						<p className="text-sm text-muted-foreground leading-relaxed">
							{t('subscribe.what_is_zone_modal.pricing_description')}
						</p>
					</div>
				</div>

				{/* Footer */}
				<div className="px-6 py-4 flex justify-end">
					<Button
						variant="outline"
						onClick={onClose}
						className="rounded-full px-6"
					>
						{t('actions.close')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default WhatIsZoneModal
